import { useSelector } from 'react-redux';

import { Grid, MenuItem } from '@material-ui/core';
import { SelectValidator } from 'react-material-ui-form-validator';

import {
  DESTINOS_COMPROBANTE,
  TIPO_COMPROBANTE,
  TIPO_COMPROBANTE_DOCUMENTO,
  TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES,
} from '../../../../utils/constants';
import { useMesaEntrada } from '../../../../hooks/useCases/useMesaEntrada';

export const TramiteComprobanteForm = ({
  formValues,
  handleInputChange,
  presupuesto,
  cotizacion,
  ospeDirecto,
  ...props
}) => {
  const { dataTransfer } = useMesaEntrada();
  const {
    destinos,
    recepcionMenu,
    tipoEfectorMenu,
    proformaTomada,
    menuProforma,
    tipoComprobanteDocumentoMenu,
  } = useSelector((state) => state.mesaEntrada);
  const menuEmbargo = tipoComprobanteDocumentoMenu === TIPO_COMPROBANTE_DOCUMENTO.EMBARGO;

  const tramites = dataTransfer.tramites
    .filter(({idTipoExpediente}) => idTipoExpediente === recepcionMenu || ospeDirecto)
    .filter(({idTipoEfector}) => !idTipoEfector || idTipoEfector === tipoEfectorMenu);

  const handleChangeTramite = (value) => {
    props.setearVariosValores({
      idTramite: value,
      idDestino:
        dataTransfer.tramites.find((item) => item.idTramite === value)?.idDestino || '',
      idTipoComprobante:
        presupuesto ?
          TIPO_COMPROBANTE.PRESUPUESTO :
          value === TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.RECIBO
            ? TIPO_COMPROBANTE.RECIBO
            : TIPO_COMPROBANTE.FACTURA,
    });
  };

  return (
    <Grid container justify="space-between">
      <Grid item xs={5}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Tramite"
          name="idTramite"
          value={formValues?.idTramite}
          onChange={(e) => handleChangeTramite(e.target.value)}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
          validators={['required']}
          disabled={
            cotizacion || ospeDirecto ||
            (menuEmbargo 
              ? tramites.filter(({embargo}) => embargo)
              : tramites
            ).length === 1 ||
            (proformaTomada !== null && !menuProforma) ||
            !!formValues?.idProforma
          }
          errorMessages={['Este campo es obligatorio']}
          style={{ color: '#000' }}
        >
          {(menuEmbargo 
            ? tramites.filter(({embargo}) => embargo)
            : tramites
            ).map((e) => (
            <MenuItem key={e.idTramite} value={e.idTramite}>
              {e.descripcion}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>
      <Grid item xs={5}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Destino"
          name="idDestino"
          value={formValues?.idDestino}
          InputLabelProps={{ style: { fontWeight: 'bold' } }}
          onChange={handleInputChange}
          validators={['required']}
          disabled={
            cotizacion || (proformaTomada !== null && !menuProforma) ||
            !!formValues?.idProforma
          }
          errorMessages={['Este campo es obligatorio']}
          style={{ color: '#000' }}
        >
          {destinos
            .filter(
              (item) => item.idDestino !== DESTINOS_COMPROBANTE.MESA_ENTRADA,
            )
            .map((e) => (
              <MenuItem key={e.id} value={e.id}>
                {e.descripcion}
              </MenuItem>
            ))}
        </SelectValidator>
      </Grid>
    </Grid>
  );
};
